import { useState, useRef,useEffect,useMemo } from "react"
import { useProject } from "../Providers"
import styleform from "../common/setting.module.scss"
import axios from "axios"
import ControlPanel from "../ControlPanel"
//import DatePicker from "react-datepicker";
//import "react-datepicker/dist/react-datepicker.css";
//import styled from "styled-components";
import {useDropzone} from 'react-dropzone'
//import {bin2hex } from  "../../lib/led/helper.js";
import {bmp_resource_create_from_bytes, bmp_resource_get_pixel} from  "./bmputil.js";
//import { ko } from 'date-fns/esm/locale';

export default function LedBMP() {	

	const { project, setting, setProject, setSetting } = useProject()
	const [startDate, setStartDate] = useState();
	const [endDate, setEndDate] = useState();
	//const [upfile, setUpfile] = useState("");

	const [imageUrl, setImageUrl] = useState('');
    const [files, setFiles] = useState([]);
	const [bmpdata, setBmpdata] = useState();
    // const [imageSrc, setImageSrc] = useState(undefined);
    // const updateFiles = (incommingFiles) => {
    //   console.log("incomming files", incommingFiles);
    //   setFiles(incommingFiles);
    // };
    // const handleSee = (imageSource) => {
    //   setImageSrc(imageSource);
    // };

	const thumbsContainer = {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		marginTop: 5,
		marginBottom : 10,
		width: 760,
		height: 128,
		border: '1px solid #eaeaea',
	  };
	  
	  const thumb = {
		display: 'inline-flex',
		borderRadius: 2,
		border: '1px solid #eaeaea',
		marginBottom: 8,
		marginRight: 0,
		width: 760,
		height: 128,
		padding: 0,
		boxSizing: 'border-box'
	  };

	//   const dropzone = {
	// 	display: 'flex',
	// 	borderRadius: 2,
	// 	border: '1px solid #eaeaea',
	// 	marginBottom: 8,
	// 	marginRight: 8,
	// 	padding: 4,
	// 	boxSizing: 'border-box'
	//   };
	  
	  const thumbInner = {
		display: 'flex',
		minWidth: 0,
		overflow: 'hidden'
	  };
	  
	  const img = {
		display: 'block',
		width: 'auto',
		height: '100%'
	  };
	  
	  const baseStyle = {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		padding: '5px',
		borderWidth: 2,
		borderRadius: 2,
		borderColor: '#eeeeee',
		borderStyle: 'dashed',
		backgroundColor: '#fafafa',
		color: '#ff0000',
		outline: 'none',
		transition: 'border .24s ease-in-out'
	  };
	  
	  const focusedStyle = {
		borderColor: '#2196f3'
	  };
	  
	  const acceptStyle = {
		borderColor: '#00e676'
	  };
	  
	  const rejectStyle = {
		borderColor: '#ff1744'
	  };

 
	const {getRootProps,
		getInputProps,
		isFocused,
		isDragAccept,
		isDragReject} = useDropzone({
		accept: {
		'image/*': []
		},
		onDrop: acceptedFiles => {
			setFiles(acceptedFiles.map(file => Object.assign(file, {
				preview: URL.createObjectURL(file)
			})));

			const reader = new FileReader()
	        //reader.readAsDataURL(acceptedFiles[0])
			reader.readAsBinaryString(acceptedFiles[0])
			reader.onload = () => {
				if (!!reader.result) {
					setBmpdata(reader.result)
					//console.log('reader.result', reader.result)
				}
			}
		}
	});
	
	const thumbs = files.map(file => (
		<div style={thumb} key={file.name}>
		<div style={thumbInner}>
			<img
			src={file.preview}
			style={img}
			// Revoke data uri after image is loaded
			onLoad={() => { URL.revokeObjectURL(file.preview) }}
			/>
		</div>
		</div>
	));

	const style = useMemo(() => ({
		...baseStyle,
		...(isFocused ? focusedStyle : {}),
		...(isDragAccept ? acceptStyle : {}),
		...(isDragReject ? rejectStyle : {})
		}), [
			isFocused,
			isDragAccept,
			isDragReject
		]);
	
	useEffect(() => {
		// Make sure to revoke the data uris to avoid memory leaks, will run on unmount
		return () => files.forEach(file => URL.revokeObjectURL(file.preview));
	}, []);

	
	const [form, setForm] = useState({
		screenno : "", 
		screenname : "", 
		desc : "", 
		iSecs: 3,
		mediatype:2,
		listid:1,
		effect:0,
	})	

	useEffect(() => {
		if(setting && setting.screen ) 
		{
			setBmpdata(null);

			const fetchImage = async () => {
				try {

					const resp = await axios.get( `${process.env.REACT_APP_PUBLIC_API_URL}/downloadfile`,{
						responseType: 'blob', // blob 형식으로 응답을 받음
						params: {
							filename: setting.screen.filename,
						},
					});
					if(resp.data){
						const url = URL.createObjectURL(resp.data);
						setImageUrl(url);

						// setFiles([{
						// 	name : setting.screen.filename,
						// 	preview: {url}
						// }]);
					}
				} catch (error) {
					console.error('Error fetching image:', error);
				}
			};
 
			fetchImage();
 
			// setFiles([{
			// 	name : setting.screen.filename,
			// 	preview: `${process.env.REACT_APP_PUBLIC_URL}/download/${setting.screen.filename}`
			// }]);

			//setting.screen.filename ? setUpfile(setting.screen.filename):setUpfile(' '), 
			//setting.screen.stardate ? setStartDate(new Date(setting.screen.stardate)):setStartDate(null),
			//setting.screen.enddate ? setEndDate(new Date(setting.screen.enddate)):setEndDate(null)

			setSetting({
				...setting,
				screen:null,
			});

			setForm({
				...form, 
				screenno : setting.screen.screenno, 
				screenname : setting.screen.screenname,
				desc : setting.screen.desc,
				iSecs: setting.screen.iSecs,
				mediatype: setting.screen.mediatype,
				bmpbuf:setting.screen.bmpbuf,
				effect:setting.screen.effect,
				msg:"",
			});
		}
	}, [setting && setting.screen? setting.screen:null]);	

	const dateToString = (date) => {
		return date.getFullYear() + '-' + (date.getMonth() + 1).toString().padStart(2, '0') + '-' + date.getDate().toString().padStart(2, '0')
	}

	const handleChange = (e) =>{
		setForm({
			...form,
			[e.target.name]: e.target.value,
			msg:'',
		})
	}

	const handleSubmit = () => {
		if (
			form.screenno === "" ||
			form.screenname === ""
		)
			return
	}

	function getledbmp(resource) {

		let date = String(form.screenno).padEnd(10);
  		//let filename = "FSYSTEMU";//date+".txt"; //파일명
		let filename = form.screenname

	    var width = resource.width;
		var height = resource.height;
		let sinario = 8;
		let flen = 0x40 + sinario + 4 + height*width/2 + 2;

		let rem = parseInt(flen / 256);
		if( flen > rem*256) rem += 1
		flen = rem*256; 
		let bytes = new Uint8Array(flen);

		for(let i=0; i<filename.length; i++) bytes[i]=filename.charCodeAt(i) 
		let str1 = "F" + String(form.screenno) + "U"
		for(let i=0; i<str1.length; i++) bytes[i+0x10]=str1.charCodeAt(i)  
		bytes[0x20] = Number('0x'+date.substring(2,4)); //날짜
		bytes[0x21] = Number('0x'+date.substring(4,6))
		bytes[0x22] = Number('0x'+date.substring(6,8))
		bytes[0x23] = Number('0x'+date.substring(8,10))
		for(let i=0; i<4; i++) bytes[i+0x26]= 0xFF;
		
		let ts1 = 0x48; //text 시작

		bytes[0x2B]= 0x01; //시나리오1
		bytes[0x41]= ts1;//file loc 
		bytes[0x42]= (form.effect)? form.effect:0x00;
		bytes[0x43]= (form.iSecs)? form.iSecs:0x1E; //3초	//bytes[0x48]= 0x44;	bytes[0x49]= 0x45; //고정

		bytes[ts1] = 0x42; bytes[ts1+1] = 0x4D;//'BM';

		let Xdan = parseInt(width / 16);
		//if( width > Xdan * 16) Xdan += 1
		let Ydan = parseInt(height / 16);
		//if( height > Ydan*16) Ydan += 1

		bytes[ts1+2] = Ydan; bytes[ts1+3] = Xdan;//0x0B;//2x11';

		let seq=0;
		var bit = 0x00; //2Pixel당 1Byte에 0b00RGBRGB 
		for (let y = 0; y < height; y++) {
			for (let x = 0; x < width; x++) { //Math.min( 16*bytes[ts1+3], width)
				var color = bmp_resource_get_pixel(resource, x, y);
				if(x%2==0){
					bit = 0x00;
					if(color[0] > 125 ) bit |= 0x20;
					if(color[1] > 125 ) bit |= 0x10;
					if(color[2] > 125 ) bit |= 0x08;

					if(bit & 0x38 == 0x00){
						if(color[0] > 10 ) bit |= 0x20;
						if(color[1] > 10 ) bit |= 0x10;
						if(color[2] > 10 ) bit |= 0x08;
					}
				}
				else{
					if(color[0] > 125 ) bit |= 0x04;
					if(color[1] > 125 ) bit |= 0x02;
					if(color[2] > 125 ) bit |= 0x01;

					if(bit & 0x07 == 0x00){
						if(color[0] > 10 ) bit |= 0x20;
						if(color[1] > 10 ) bit |= 0x10;
						if(color[2] > 10 ) bit |= 0x08;
					}
					bytes[ts1 + 4 + seq++] = bit;
				}
				// if (color[0] == pr &&
				// 	color[1] == pg &&
				// 	color[2] == pb)
				// 	bmp_resource_set_pixel(resource_new, x, y, cr, cg, cb);
			}
		}

		bytes[ts1 + 4 + seq++] = 0x0D; bytes[ts1 + 4 + seq++] = 0x0A;
	
		return bytes;
	}

	const handleApply = async (event, value) => {
		event.preventDefault();

		if(files.length > 0 ){
			let file = files[0];

			if(bmpdata){
				// var data = bmpdata.split('');
				// var data_len = data.length;
				// let bytes = new Uint8Array(data_len);
				// for (var i = 0; i < data_len; i++) {
				//  	var value = bin2hex(data[i]);
				// 	 bytes[i] = parseInt(value,16);
			
				// // 	if (value.length > 2) {
				// // 		value = value.substr(2, 2);
				// // 		data[i] = hex2bin(value);
				// // 	}
				// }
				// //data =  data.join('');

				var resource = bmp_resource_create_from_bytes(bmpdata,true)
				//var imagesrc = bmp_create_uri(resource);
				var newbuffer = getledbmp(resource);
		
				const link = document.createElement( 'a' );
				link.style.display = 'none';
				document.body.appendChild( link );

				const blob = new Blob( [ newbuffer ], { type: 'application/octet-stream' } )
				link.href = URL.createObjectURL( blob );
				link.download = form.screenno + ".ebs";
				link.click();
			}
			else if( form.bmpbuf ){
				const link = document.createElement( 'a' );
				link.style.display = 'none';
				document.body.appendChild( link );

				var buf = Buffer.from(form.bmpbuf, 'base64');
				let filename = form.screenname
				for(let i=0; i<filename.length; i++) buf[i]=filename.charCodeAt(i) 
				for(let i=filename.length; i<0x10-1; i++) buf[i]=0x00; 
				let str1 = "F" + String(form.screenno) + "U"
				for(let i=0; i<str1.length; i++) buf[i+0x10]=str1.charCodeAt(i)  
				for(let i=str1.length+0x10; i<0x20-1; i++) buf[i]=0x00; 
				buf[0x42]= (form.effect)? form.effect:0x00;
				buf[0x43]= (form.iSecs)? form.iSecs:0x1E;

				const blob = new Blob( [ buf ], { type: 'application/octet-stream' } )
				link.href = URL.createObjectURL( blob );
				link.download = form.screenno + ".ebs";
				link.click();
			}
		}
	}

	const handleAddscreen = async (event, value) => {
		event.preventDefault();

		if ( !(parseInt(form.screenno) > 0) ){
				setForm({
					...form,
					msg: "ID 를 입력하세요"
				})
				return
			}
			//form.screenname === ""

		let file = null;
		if(files.length > 0 ){
			file = files[0];

			const formData = new FormData();
			formData.append('file', file);

			try {
				const res = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/uploadFile`, formData, {
					headers: {
					'Content-Type': 'multipart/form-data'
					},
				});
				if (res.status == 200) {
					setForm({
						...form,
						msg: '업로드 되었습니다'
					})
				} else {
					setForm({
						...form,
						msg: res.data.message
					})
				}
			} catch (err) {
				setForm({
					...form,
					msg: "파일을 선택하세요"
				})
			}
		}
		else {
			setForm({
				...form,
				msg: "파일을 선택하세요"
			})
			return;
		}

		var bmpbuffer = null;
		if(bmpdata){
			var resource = bmp_resource_create_from_bytes(bmpdata,true)
			bmpbuffer = getledbmp(resource);
		}
		else if( form.bmpbuf ){
			bmpbuffer = Buffer.from(form.bmpbuf, 'base64');
			bmpbuffer[0x42]= (form.effect)? form.effect:0x00;
			bmpbuffer[0x43]= (form.iSecs)? form.iSecs:0x1E;
		}

		var ob = {};
        ob.screenno = parseInt(form.screenno);
        ob.screenname = form.screenname;
		ob.desc = form.desc;
        ob.filename = (file)?file.name:'';
		ob.stardate = '';//startDate? dateToString(startDate) :''
		ob.enddate = '';//endDate? dateToString(endDate) : '';
		ob.lat = '';
		ob.lng = '';
		ob.iSecs = form.iSecs;
		ob.effect = form.effect;
		ob.mediatype = form.mediatype;
		ob.listid = form.listid;
		ob.bmpbuf = (bmpbuffer)? Buffer.from(bmpbuffer.buffer, 'base64'):'';
        console.log(ob);

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('로그인 해주세요!');
		}
		try {
			const resp = await axios.post(`${process.env.REACT_APP_PUBLIC_API_URL}/screens`,
			{
				ob
			},
			{
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (resp.data.ok) {
				setForm({
					...form,
					msg: '저장되었습니다'
				})
				setSetting({
					...setting,
					imagechg : 1,
				})
			} else {
				setForm({
					...form,
					msg: resp.data.message
				})
			}
		} catch (err) {
			alert(err);
		}
	};

	const handleDelscreen = async (event, value) => {
		event.preventDefault();

		if (
			form.screenno === "0" ||
			form.screenno === ""
		)return

		const token = localStorage.getItem('accessToken');
		if (token === null) {
			alert('로그인 해주세요!');
		}
		try {
			const resp = await axios.delete(`${process.env.REACT_APP_PUBLIC_API_URL}/screens`,{
				data : {
					screenno : form.screenno
				},
				headers: {
					Authorization: `Bearer ${token}`,
				},
			});
			if (resp.data.ok) {
				setForm({
					...form,
					msg: '삭제되었습니다'
				})

				setSetting({
					...setting,
					imagechg : 1,
				})
			} else {
				setForm({
					...form,
					msg: resp.data.message
				})
			}
		} catch (err) {
			alert(err);
		}
	};

	// const SDatePicker = styled(DatePicker)`
	// 	width:125px;
	// 	height:30px;
	// 	box-sizing:border-box;
	// 	border-radius:4px;
	// 	font-size:14px;
	// 	background-color:#474747;
	// 	padding:6px;
	// 	border:1px solid;
	// `;

	// function getsource()
	// {
	// 	let src='';
	// 	if(trackList && trackList.length > 0 ) src = trackList[0].url;
	// 	else if( upfile ) src = `${process.env.REACT_APP_PUBLIC_API_URL}/download/${upfile}`;
	// 	else src = `${process.env.REACT_APP_PUBLIC_API_URL}/img/media.png`
	// 	return src
	// }

	return (
		<div className = {styleform.defaultModal} style={{ display: 'flex', marginLeft:'1px', marginTop: '50px'}}>
		<div style={{  flex: '50%', marginLeft:'10px', width:'760px',marginTop:'15px'}}>	
		<div className={styleform.wrapper2} style={{width:'760px',height:"520px"}}>
			<label className={styleform.linecs} style={{marginTop:'-8px'}}>LED Image Editor</label>
			<div style={{marginTop:'30px'}}>
				<label>ID</label>
				<input
					className={styleform.input}
					type='text'
					name='screenno'
					placeholder='ID'
					maxLength='16'
					value={form.screenno}
					onChange={handleChange}
					spellCheck="false"
					style={{marginLeft:'10px',marginRight:'20px',width:'150px'}}
				/>	
				<label >Image Name</label>
				<input
					className={styleform.input}
					style={{marginLeft:'10px',width:'250px', marginBottom:'20px'}}
					type='text'
					name='screenname'
					placeholder='이미지명'
					maxLength='16'
					value={form.screenname}
					onChange={handleChange}
					spellCheck="false"
				/>
			</div>
			<div>
				{/* <label>설명</label>
				<textarea
						style={{height:'40px'}}
						type='text'
						name='desc'
						placeholder='설명'
						maxLength='50'
						value={form.desc}
						onChange={handleChange}
				/> */}
				<section className="container" >
					<div {...getRootProps({style})}>
						<input {...getInputProps()} />
						{/* <p style={{color:'#2196f3'}}>이곳에 BMP파일을 드롭하거나 클릭하세요</p> */}
						{/* <p style={{color:'#2196f3'}}>Drag 'n' drop BMP file here, or click to select file</p> */}
						<p style={{color:'#2196f3'}}>BMP파일을 이곳에 드롭하거나 클릭하여 파일을 선택하세요</p>
					</div>
					<aside style={thumbsContainer}>
						{thumbs}
					</aside>
				</section>
			</div>
			<div>
               { imageUrl && <img src={imageUrl} alt="Fetched from server" />}
           </div>

			<div>
				
				{/* <label style={{width:'600px',marginLeft:'10px', color:'#eeeeee'}}>재생효과</label> */}
				<label style={{marginLeft:'10px'}}>Display Time</label>
				<input
					className={styleform.input}
					type='text'
					name='iSecs'
					placeholder='이미지표출시간'
					maxLength='16'
					value={form.iSecs}
					onChange={handleChange}
					spellCheck="false"
					style={{marginLeft:'10px',width:'50px', marginRight:'10px'}}
				/>
				<label style={{marginRight:'10px'}}>Display Effect</label>
				<select
					style={{width: '100px'}}
					className={styleform.canvasTemplate}
					name='effect'
					onChange={handleChange}
					value={form.effect}
				>
						<option value={0}>None</option>
						<option value={1}>Flash</option>
						<option value={2}>Color Reversal</option>
						<option value={3}>Move Bottom</option>
						<option value={4}>Move Top</option>
						<option value={5}>Move Right</option>
						<option value={6}>Move Left</option>
				</select>		
			</div>						
				{/* <div className={stylemodal.modalMid2} style={{marginTop:'10px',width:'350px', marginRight:'5px'}}>
					<label style={{width:'150px',marginRight:'5px'}}>방송기간</label>
					<SDatePicker dateFormat="yyyy년 MM월 dd일"
							selected={startDate} onChange={date => setStartDate(date)}
					/>
					<p>&nbsp;_&nbsp;</p>
					<SDatePicker dateFormat="yyyy년 MM월 dd일"
							selected={endDate} onChange={date => setEndDate(date)}
					/>
				</div> */}
				<label style={{ color:"#C3602C"}} value={form.msg}>{form.msg}</label>
				<div style={{marginTop:'10px',marginLeft:'20px'}}>
					<button className={styleform.button} onClick={handleAddscreen}>Save</button>
					<button className={styleform.button} onClick={handleDelscreen}>Delete</button>
					<button className={styleform.button} onClick={handleApply}>File</button>
			</div>
			</div>
			</div>
			<div style={{  flex: '60%', marginLeft:'10px'}}>	
				{<ControlPanel menu="image" />}
			</div>
		</div>
	)
}
